export default "__VITE_ASSET__EgUkNz96__"